function resolveApiUrl(): string {
  const fromEnv = process.env.REACT_APP_API_URL?.replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    return '/api';
  }
  return 'http://localhost:5001/api';
}

const API_URL = resolveApiUrl();

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export type InfoPageKey = 'about' | 'privacy' | 'legal';

export interface InfoPageSection {
  id: string;
  title: string;
  content: string;
  enabled: boolean;
  order: number;
}

export interface InfoPageValue {
  icon: string;
  title: string;
  description: string;
  enabled: boolean;
  order: number;
}

export interface InfoPageStat {
  value: string;
  label: string;
  enabled: boolean;
  order: number;
}

export interface InfoPageData {
  pageKey: InfoPageKey;
  layout: 'about' | 'prose';
  page: {
    title: string;
    subtitle: string;
    bannerImageUrl?: string;
    bannerOverlayOpacity?: number;
    lastUpdated?: string;
    heroIcon?: string;
  };
  sections: InfoPageSection[];
  values: InfoPageValue[];
  stats: InfoPageStat[];
  isPublished?: boolean;
}

export async function fetchPublicInfoPage(pageKey: InfoPageKey): Promise<InfoPageData | null> {
  const res = await fetch(`${API_URL}/info-pages/${pageKey}`);
  const json = await res.json();
  if (!res.ok || !json.success) return null;
  return json.data as InfoPageData;
}

export async function fetchAdminInfoPage(pageKey: InfoPageKey): Promise<InfoPageData> {
  const res = await fetch(`${API_URL}/admin/info-pages/${pageKey}`, { headers: authHeaders() });
  const json = await res.json();
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Failed to load page');
  }
  return json.data as InfoPageData;
}

export async function saveAdminInfoPage(pageKey: InfoPageKey, data: InfoPageData): Promise<InfoPageData> {
  const res = await fetch(`${API_URL}/admin/info-pages/${pageKey}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Failed to save page');
  }
  return json.data as InfoPageData;
}
